// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","menu_close":"Menu_menu_close__+w4ik","menu_container":"Menu_menu_container__XSwcc","menu_item":"Menu_menu_item__kpGCV"};